import { GridColumnHeader, SortDirection } from '../components/Grid/types';
import { Attribute, DataSource } from '../types/entities.types';

const gridHeaders: GridColumnHeader[] = [
  {
    name: 'businessMetadata.asset_name',
    label: 'Endpoint Name',
    width: '30%',
    filter: {
      type: 'text',
      remoteSearchFields: ['asset_name'],
    },
    sortable: true,
    remoteSortField: 'asset_name',
    defaultSortBy: 'asset_name',
    defaultSortType: SortDirection.ASC,
  },
  {
    name: 'technicalMetadata.asset_status',
    label: 'Status',
    width: '20%',
    filter: {
      type: 'aggregation',
      aggregationName: 'asset_status_aggregation',
      remoteSearchFields: ['asset_status'],
      filterSelectProps: {
        isClearable: true,
      },
    },
  },
  {
    name: 'sourceSpecificMetadata.SageMakerMLEndpoint.aws_account',
    label: 'AWS Account',
    width: '20%',
    filter: {
      type: 'aggregation',
      aggregationName: 'aws_account_aggregation',
      remoteSearchFields: ['aws_account'],
      filterSelectProps: {
        isClearable: true,
      },
    },
  },
];

const attributesMap: Attribute[] = [
  // Column 0 - Basic Information
  {
    name: 'businessMetadata.asset_id',
    label: 'Asset ID',
    showInColumn: 0,
    description: 'Unique identifier for the SageMaker endpoint',
  },
  {
    name: 'businessMetadata.asset_name',
    label: 'Endpoint Name',
    showInColumn: 0,
    description: 'Name of the SageMaker endpoint',
  },
  {
    name: 'technicalMetadata.asset_status',
    label: 'Status',
    showInColumn: 0,
    description: 'Current status of the endpoint',
  },
  {
    name: 'technicalMetadata.created_time',
    label: 'Created Time',
    showInColumn: 0,
    type: 'date',
    description: 'When the endpoint was created',
  },
  {
    name: 'technicalMetadata.usageMetadata.last_altered',
    label: 'Last Modified',
    showInColumn: 0,
    type: 'date',
    description: 'When the endpoint was last modified',
  },

  // Column 1 - Configuration
  {
    name: 'sourceSpecificMetadata.SageMakerMLEndpoint.aws_account',
    label: 'AWS Account',
    showInColumn: 1,
    description: 'AWS Account ID where the endpoint is hosted',
  },
  {
    name: 'sourceSpecificMetadata.SageMakerMLEndpoint.tags',
    label: 'Tags',
    type: 'table',
    showInColumn: 2,
    description: 'Tags associated with the endpoint',
    tableColumns: ['Tag Name', 'Value'],
    tableFieldMapping: {
      'Tag Name': 'name',
      Value: 'value',
    },
  },
  {
    name: 'sourceSpecificMetadata.SageMakerMLEndpoint.production_variants',
    label: 'Production Variants',
    type: 'table',
    showInColumn: 1,
    description: 'Production variant configurations',
    tableColumns: ['Variant Name', 'Model Name', 'Instance Type', 'Instance Count', 'Weight'],
    tableFieldMapping: {
      'Variant Name': 'variant_name',
      'Model Name': 'model_name',
      'Instance Type': 'instance_type',
      'Instance Count': 'initial_instance_count',
      Weight: 'initial_variant_weight',
    },
  },
];

const customQueryForListPage = `
  SageMakerMLEndpoint {
    aws_account
  }
`;

const customQueryForDetailsPage = `
  SageMakerMLEndpoint {
    aws_account
    tags {
      name
      value
    }
    production_variants {
      initial_instance_count
      initial_variant_weight
      instance_type
      model_name
      variant_name
    }
  }
`;

export const SageMakerMLEndpointConfig: DataSource = {
  id: '19',
  name: 'SageMakerMLEndpoint',
  category: 'servingEndpoint',
  label: 'SageMaker ML Endpoints',
  dataSourceLabel: 'SageMaker ML Endpoints',
  showColumns: false,
  showPartitionColumns: false,
  showLineage: true,
  showLineageTable: false,
  showLineageQuery: false,
  showLineageCloned: false,
  showLineageCW: false,
  showLineagePipeline: false,
  showLineageDashboard: false,
  gridHeaders,
  attributesMap,
  customQueryForListPage,
  customQueryForDetailsPage,
  glossary: false,
};
